var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gensee-video-player',{attrs:{"auto-play":true,"video-id":_vm.videoSourceId}})}
var staticRenderFns = []

export { render, staticRenderFns }